import React from 'react';
export function Footer() {
  return <footer className="bg-verdeOscuro text-white py-16 px-4 text-center" data-id="element-89">
      <div className="max-w-4xl mx-auto" data-id="element-90">
        <p className="text-lg md:text-xl font-medium mb-4 flex items-center justify-center gap-2" data-id="element-91">
          🧘 YOGA 360 — El sistema de planificación N°1 para profesores de yoga.
        </p>

        <p className="text-gray-400 italic mb-12 max-w-2xl mx-auto" data-id="element-92">
          "Porque preparar una buena clase no debería costarte todas las noches
          de la semana."
        </p>

        <div className="mb-12" data-id="element-93">
          <h3 className="text-2xl font-bold tracking-widest mb-6" data-id="element-94">
            🧘 YOGA 360™
          </h3>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-gray-300" data-id="element-95">
            <a href="mailto:contacto@yoga360.com.ar" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-96">
              📧 contacto@yoga360.com.ar
            </a>
            <span className="hidden md:inline text-gray-600" data-id="element-97">|</span>
            <a href="#" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-98">
              📲 @yoga360.ar
            </a>
            <span className="hidden md:inline text-gray-600" data-id="element-99">|</span>
            <a href="#" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-100">
              🌐 www.yoga360.ar
            </a>
          </div>
        </div>

        <div className="text-sm text-gray-500 border-t border-gray-800 pt-8" data-id="element-101">
          <p className="mb-2" data-id="element-102">
            © YOGA 360™ 2025 — Todos los derechos reservados.
          </p>
          <p className="mb-2" data-id="element-103">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p data-id="element-104">
            El material incluye ejercicios graficados. Las imágenes mostradas
            son completamente ilustrativas y pueden no coincidir exactamente con
            el texto.
          </p>
        </div>
      </div>
    </footer>;
}